import { render, staticRenderFns } from "./ProductionStatuses.vue?vue&type=template&id=607fe34a&lang=pug&"
import script from "./ProductionStatuses.vue?vue&type=script&lang=js&"
export * from "./ProductionStatuses.vue?vue&type=script&lang=js&"
import style0 from "./ProductionStatuses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports